<template>
  <div id="app" class="font-sans antialiased flex flex-col">
    <router-view v-if="!loading" />
  </div>
</template>

<script>
import teamsClient from "@/api/merchant/teams";

export default {
  data() {
    return {
      loading: true
    };
  },

  mounted() {
    this.initAuthentication().then(() => {
      this.ensureTeamMembership().then(() => (this.loading = false));
    });
  },

  methods: {
    ensureTeamMembership() {
      return teamsClient.index().then(async ({ data }) => {
        let defaultOrNewTeamId = this.needsOnboarding(data.data.teams)
          ? (await teamsClient.store()).data.data.id
          : data.data.defaultTeam.id;

        return (
          !this.isTeamMember(data.data.teams) &&
          this.pushToTeam(defaultOrNewTeamId)
        );
      });
    },

    initAuthentication() {
      return this.$store.dispatch("authentication/init");
    },

    needsOnboarding(teams) {
      return teams.length == 0;
    },

    isTeamMember(teams) {
      return teams.filter(el => el.id == this.$route.params.agency).length > 0;
    },

    pushToTeam(id) {
      this.$router.push({
        name: "dashboard",
        params: { agency: id }
      });
    }
  }
};
</script>
